<template lang="pug">
.Box-notice._relative._mb2._radius._px075._py05._flex._flex-alignItemsCenter(v-if="verifyingEmailBusy") 
   LoadingInline(iconSize="20px" class="_c-yellow-700")
   ._ml075 Verifying your email
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
   data() {
      return {
         emailToConfirm: this.$route.query.emailConfirmation,
         verifyingEmailBusy: false,
         emailConfirmationSuccess: false,
         emailConfirmationError: false,
      }
   },
   methods: {
      confirmEmail(emailToConfirm) {
         return this.$store
            .dispatch('confirmEmail', emailToConfirm)
            .then(() => {
               this.emailConfirmationSuccess = true
               this.$snotify.success('Email confirmed')
            })
            .catch(() => {
               this.emailConfirmationError = true
            })
            .finally(() => {
               this.verifyingEmailBusy = false
            })
      },
      removeQueryString(toRemove) {
         let query = Object.assign({}, this.$route.query)
         delete query[toRemove]
         this.$router.replace({query})
      },
      onInitHandlerForEmailVerification() {
         this.verifyingEmailBusy = true
         this.confirmEmail(this.emailToConfirm)
         this.removeQueryString('emailConfirmation')
      },
   },
   // Should this be `mounted` ? See https://gridsome.org/docs/client-side-data#fetch-from-internal-pages
   created() {
      if (this.emailToConfirm) {
         this.onInitHandlerForEmailVerification()
      }
   },
}
</script>
